import { rei } from "@/services/api"

class MedicosService {
  static storeMedicos (obito_id, params) {
    return rei.post(`medicos`, { obito_id,  ...params }).then(res => res.data)
  }

  static updateMedico (idMedico, params) {
    return rei.put(`medicos/${idMedico}`, { params }).then(res => res.data)
  }

  static deleteMedico (idMedico) {
    return rei.delete(`medicos/${idMedico}`).then(res => res.data)
  }
}

export default MedicosService
